import {
  MdOutlineWifi as IconWifi,
  MdSignalWifi0Bar as IconWifi0,
  MdSignalWifi1Bar as IconWifi1,
  MdSignalWifi2Bar as IconWifi2,
  MdSignalWifi3Bar as IconWifi3,
  MdSignalWifi4Bar as IconWifi4,
} from 'react-icons/md';

import IconAquatek from '../images/aquatek.png';
import IconPooltek from '../images/waterco.png';
import IconOasis from '../images/oasis.png';
import IconTheralink from '../images/theralux.png';
import IconAqualight from '../images/aqualight.png';
import IconHenden from '../images/henden_box.png';
import IconCHilli from '../images/chilli_box.png';
import IconUnknown from '../images/unknown.png';
import IconSWCDontek from '../images/swc_dontek.png';
import IconSWCHenden from '../images/swc_henden.png';

import IconBrandAquatek from '../images/logo_aquatek.png';
import IconBrandWaterCo from '../images/logo_waterco.png';
import IconBrandHenden from '../images/logo_henden.png';
import IconBrandOasis from '../images/logo_oasis.png';
import IconBrandTheralux from '../images/logo_theralink.png';
import IconBrandAqualight from '../images/logo_aqualight.png';
import IconBrandSummerTime from '../images/logo_chilli.png';
import IconBrandUnknown from '../images/unknown.png';
import IconBrandInstatouchWifi from '../images/logo_instatouch_wifi.jpg';
import IconBrandDontek from '../images/logo_dontek.png';

import { APP_CONFIG, modelTypeDetails, modelTypeDetails_no_SWC, controller_t, mType_label_t } from '../constants';
import { devLog } from './devLog';

export const convertDeviceToIconNumber = (controllerString) => {
  var the_icon = 254;
  if (controllerString !== undefined) {
    var controllerUC = 'Unknown';
    try {
      controllerUC = controllerString.toUpperCase();
    } catch (error) {
      devLog('convertDeviceToIconNumber failed', controllerString);
    }
    var modelTypes = APP_CONFIG.SWC_ENABLED ? modelTypeDetails : modelTypeDetails_no_SWC;

    const match = modelTypes.find((type) => type.label.toUpperCase() === controllerUC);
    if (match) {
      the_icon = match.value;
    }
  }
  return the_icon;
};

export const getControllerIconText_FROM_STRING = (controllerString) => {
  var the_icon = convertDeviceToIconNumber(controllerString);
  return getControllerIconText(the_icon);
};

export const getControllerIconText = (controllerValue) => {
  var theIcon = IconUnknown;
  var theText = 'Unknown';
  switch (controllerValue) {
    case controller_t.AQUATEK:
      theIcon = IconAquatek;
      theText = mType_label_t.AQUATEK;
      break;
    case controller_t.THERALINK:
      theIcon = IconTheralink;
      theText = mType_label_t.THERALINK;
      break;
    case controller_t.OASIS:
      theIcon = IconOasis;
      theText = 'Oasis Smart';
      break;
    case controller_t.AQUALIGHT:
      theIcon = IconAqualight;
      theText = mType_label_t.AQUALIGHT;
      break;
    case controller_t.POOLTEK:
      theIcon = IconPooltek;
      theText = mType_label_t.POOLTEK;
      break;
    case controller_t.HENDEN:
      theIcon = IconHenden;
      theText = mType_label_t.HENDEN;
      break;
    case controller_t.SUMMERTIME:
      theIcon = IconCHilli;
      theText = mType_label_t.SUMMERTIME;
      break;
    case controller_t.SWC_DONTEK:
      theIcon = IconSWCDontek;
      theText = mType_label_t.SWC_DONTEK;
      break;
    case controller_t.SWC_HENDEN:
      theIcon = IconSWCHenden;
      theText = mType_label_t.SWC_HENDEN;
      break;
    case controller_t.INSTATOUCH_WIFI:
      theIcon = IconAqualight;
      theText = mType_label_t.INSTATOUCH_WIFI;
      break;
    default:
      break;
  }
  return { icon: theIcon, Text: theText };
};

export const getControllerBrandIcon_FROM_STRING = (controllerString) => {
  var the_icon = convertDeviceToIconNumber(controllerString);
  return getControllerBrandIcon(the_icon);
};

export const getWifiIconFromRssi = (rSSIregisterValue) => {
  let icon = IconWifi;
  // const regDat = registerData.find(item => item.address === REGS.WIFI_RSSI);
  // if(registerValue !== undefined) {
  let rssi = rSSIregisterValue;
  if (rssi > 0x7fff) rssi = rssi - 0x10000;
  if (rssi >= -50) {
    icon = IconWifi4;
  } else if (rssi >= -60) {
    icon = IconWifi3;
  } else if (rssi >= -70) {
    icon = IconWifi2;
  } else if (rssi >= -80) {
    icon = IconWifi1;
  } else {
    icon = IconWifi0;
  }
  // }
  return icon;
};

export const getControllerBrandIcon = (controllerValue) => {
  var brandIcon = IconBrandUnknown;

  switch (controllerValue) {
    case controller_t.AQUATEK:
      brandIcon = IconBrandAquatek;
      break;
    case controller_t.THERALINK:
      brandIcon = IconBrandTheralux;
      break;
    case controller_t.OASIS:
      brandIcon = IconBrandOasis;
      break;
    case controller_t.AQUALIGHT:
      brandIcon = IconBrandAqualight;
      break;
    case controller_t.POOLTEK:
      brandIcon = IconBrandWaterCo;
      break;
    case controller_t.HENDEN:
      brandIcon = IconBrandHenden;
      break;
    case controller_t.SUMMERTIME:
      brandIcon = IconBrandSummerTime;
      break;
    case controller_t.SWC_HENDEN:
      brandIcon = IconBrandHenden;
      break;
    case controller_t.SWC_DONTEK:
      brandIcon = IconBrandDontek;
      break;
    case controller_t.INSTATOUCH_WIFI:
      brandIcon = IconBrandInstatouchWifi;
      break;
    default:
      break;
  }
  // console.log("the ionc", brandIcon)
  return brandIcon;
};
